import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState } from 'react';
import styles from './BpoDemo.module.css';
import BpoIcon from './BpoIcon';
import { DemoButton, DemoDrawer as Drawer, MockNotice, useDemoText } from './DemoUi';
function classify(value) {
    if (/lote|todas as notas|batch|lotes/i.test(value))
        return 'batch';
    if (/fluxo|caixa|dre|cash flow|flujo/i.test(value))
        return 'flow';
    if (/nfse|nota fiscal|invoice|factura/i.test(value))
        return 'invoice';
    if (/imposto|inss|atras|tax|impuesto/i.test(value))
        return 'tax';
    if (/nota|escritura|bookkeeping/i.test(value))
        return 'bookkeeping';
    if (/resumo|carteira|m[êe]s|portfolio|summary|resumen/i.test(value))
        return 'portfolio';
    return 'default';
}
const REPLIES = {
    batch: 'batchSuccess',
    invoice: 'invoiceSuccess',
    flow: 'flow',
    tax: 'taxReply',
    bookkeeping: 'bookkeepingReply',
    portfolio: 'portfolioReply',
    default: 'defaultReply',
};
const FLOW = [
    ['01/10 a 07/10', '28.400,00', '31.200,00', '15.500,00'],
    ['08/10 a 14/10', '19.800,00', '47.700,00', '−12.400,00'],
    ['15/10 a 21/10', '46.200,00', '29.600,00', '4.200,00'],
    ['22/10 a 31/10', '48.200,00', '42.800,00', '9.600,00'],
];
export default function BpoAi({ name, onClose }) {
    const text = useDemoText();
    const [input, setInput] = useState('');
    const [messages, setMessages] = useState([]);
    const [document, setDocument] = useState(null);
    const send = (value) => {
        if (!value.trim())
            return;
        setMessages(prev => [...prev, { id: crypto.randomUUID(), value: value.trim(), reply: classify(value) }]);
        setInput('');
    };
    return (_jsxs("div", { className: styles.agent, "data-initial": messages.length === 0, children: [_jsxs("div", { className: styles.toolbar, children: [_jsxs("strong", { className: styles.aiBadge, children: [_jsx(BpoIcon, { name: 'sparkles' }), " ", text('ai')] }), _jsx(DemoButton, { secondary: true, onClick: onClose, children: text('close') })] }), _jsx("span", { className: styles.aiDemo, title: text('notice'), children: text('demonstration') }), messages.length === 0 && (_jsxs(_Fragment, { children: [_jsxs("h2", { children: [_jsx(BpoIcon, { name: 'sparkles', size: 28 }), " ", text('hello'), ", ", name] }), _jsx("div", { className: styles.suggestions, children: [
                            'cashFlowRequest',
                            'batchRequest',
                            'invoiceRequest',
                            'taxesRequest',
                            'portfolioRequest',
                            'bookkeepingRequest',
                        ].map(key => (_jsx("button", { onClick: () => send(text(key)), children: text(key) }, key))) })] })), _jsx("div", { "aria-live": 'polite', children: messages.map(m => (_jsxs(React.Fragment, { children: [_jsx("p", { className: styles.message, "data-author": 'user', children: m.value }), _jsxs("div", { className: styles.message, children: [_jsx("strong", { children: text(REPLIES[m.reply]) }), m.reply === 'batch' && _jsx("p", { children: text('batchDetail') }), m.reply === 'invoice' && (_jsxs(_Fragment, { children: [_jsx("p", { children: text('invoiceDetail') }), _jsx(DemoButton, { onClick: () => setDocument('invoice'), children: text('viewInvoice') })] })), m.reply === 'flow' && (_jsxs(_Fragment, { children: [_jsx(FlowSummary, {}), _jsx("p", { className: styles.error, children: text('negative') }), _jsx("p", { children: text('negativeDescription') }), _jsx(DemoButton, { onClick: () => setDocument('flow'), children: text('exportFlow') })] }))] })] }, m.id))) }), _jsxs("form", { className: styles.agentInput, onSubmit: e => {
                    e.preventDefault();
                    send(input);
                }, children: [_jsx("input", { "aria-label": text('ask'), placeholder: text('ask'), value: input, maxLength: 1000, onChange: event => setInput(event.target.value) }), _jsx("button", { type: 'submit', "aria-label": text('send'), disabled: !input.trim(), children: "\u2191" })] }), _jsxs(Drawer, { isOpen: !!document, title: text(document === 'invoice' ? 'invoiceSuccess' : 'flow'), onClose: () => setDocument(null), children: [_jsx(MockNotice, {}), document === 'invoice' ? (_jsxs("div", { className: styles.detail, children: [_jsx("h2", { children: text('invoiceSuccess') }), _jsx("p", { children: text('invoiceDetail') }), _jsx("p", { children: "NFSe 1204 \u00B7 R$ 4.800,00 \u00B7 ISS R$ 96,00 \u00B7 R$ 4.704,00" })] })) : (_jsxs(_Fragment, { children: [_jsx(FlowSummary, {}), _jsx("div", { className: styles.tableWrap, children: _jsxs("table", { className: styles.table, children: [_jsx("thead", { children: _jsx("tr", { children: ['period', 'inflows', 'outflows', 'projected'].map(key => (_jsx("th", { scope: 'col', children: text(key) }, key))) }) }), _jsx("tbody", { children: FLOW.map(row => (_jsx("tr", { children: row.map(cell => (_jsx("td", { children: cell }, cell))) }, row[0]))) })] }) }), _jsx("p", { className: styles.error, children: text('negative') }), _jsx("p", { children: text('negativeDescription') })] }))] })] }));
}
function FlowSummary() {
    const text = useDemoText();
    return (_jsx("div", { className: styles.detail, children: [
            ['initialBalance', 'R$ 18.300,00'],
            ['inflows', 'R$ 142.600,00'],
            ['outflows', '−R$ 151.300,00'],
            ['projected', 'R$ 9.600,00'],
        ].map(([key, value]) => (_jsxs("p", { children: [text(key), ": ", _jsx("strong", { children: value })] }, key))) }));
}
export function BpoInsights({ index, onAction, }) {
    const text = useDemoText();
    const sets = [
        [
            { title: 'insightTax', description: 'insightTaxDescription', action: 'payNow', route: 'pagar' },
            { title: 'insightDiscount', description: 'insightDiscountDescription', action: 'payDiscount', route: 'pagar' },
        ],
        [
            {
                title: 'insightOverdue',
                description: 'insightOverdueDescription',
                action: 'viewReceivables',
                route: 'receber',
            },
            { title: 'insightReform', description: 'insightReformDescription', action: 'reviewServices', route: 'services' },
        ],
        [
            { title: 'insightDates', description: 'insightDatesDescription', action: 'viewDueDates', route: 'pagar' },
            { title: 'negative', description: 'negativeDescription', action: 'anticipate', route: 'receber' },
        ],
    ];
    return (_jsx("div", { className: styles.insights, title: text('notice'), children: sets[index % sets.length].map((item, position) => {
            let severity = 'critical';
            if (position === 0)
                severity = 'attention';
            else if (index === 0)
                severity = 'insight';
            return (_jsxs("section", { className: styles.insight, "data-severity": severity, children: [_jsxs("div", { className: styles.insightHeading, children: [_jsx(BpoIcon, { name: { attention: 'warning', insight: 'bulb', critical: 'shield' }[severity] }), _jsx("span", { className: styles.severity, children: text(severity) }), _jsx("h3", { children: text(item.title) }), _jsxs("button", { type: 'button', onClick: () => onAction(item.route), children: [text(item.action), " ", _jsx("span", { "aria-hidden": 'true', children: "\u2192" })] })] }), _jsx("p", { children: text(item.description) })] }, item.title));
        }) }));
}
